import React, { useEffect, useState } from "react";
import PdfFile from "./PdfFile";
import { PDFViewer, pdf } from "@react-pdf/renderer";
import { useInvoiceProvider } from "../../../../Providers/Vendor/invoice";
import Swal from "sweetalert2";
import SimpleBackdrop from "../../../../Components/SimpleBackDrop";
import ShareLinkModal from "./ShareLinkModal";
import { useSelector } from "react-redux";
import api from "../../../../Utils/api";
import axios from "axios";

export default function Preview({
  setPreview,
  month,
  hourlyRate,
  dueDate,
  comment,
  jobDetails,
  hoursInMonth,
  setJobInfo,
}) {
  const { weeksOfMonth, createInvoice, createInvoiceWithLink } =
    useInvoiceProvider();
  const [invoiceId, setInvoiceId] = useState();
  const [invoiceno, setInvoiceno] = useState();
  const [invoicePdfLink, setInvoicePdfLink] = useState();
  const [loading, setLoading] = useState(false);
  const [disableTimesheet, setDisableTimesheet] = useState(false);
  const userDetails = useSelector((state) => state.user.details);

  const Pdf = () => (
    <PdfFile
      month={month}
      hourlyRate={hourlyRate || 0}
      dueDate={dueDate}
      comment={comment}
      weeksOfMonth={weeksOfMonth}
      jobDetails={jobDetails}
      hoursInMonth={hoursInMonth}
      invoiceId={invoiceId}
      invoiceNo={invoiceno}
      userDetails={userDetails}
    />
  );

  useEffect(() => {
    if (invoiceId) uploadInvoicePdf();
  }, [invoiceId]);

  const uploadInvoicePdf = async () => {
    setLoading(true);
    const blob = await pdf(<Pdf />).toBlob();
    const invoiceFile = new File([blob], "InvoicePdf");

    try {
      const upload = await api.get(`/user/getpresigneduploadurl?filename=${invoiceId+".pdf"}&filetype=${invoiceFile.type}&location=invoices`)

      if (upload?.data?.success && upload?.data?.result) {
        const formData = new FormData();
        formData.append("file", invoiceFile);
        const s3_res = await axios.put(upload?.data?.result, formData, {headers:{'Content-Type': 'multipart/form-data'}});

        if (s3_res.status === 200) {
          createInvoiceWithLink({ invoiceId, invoiceLink: upload?.data?.key }).then(
            (res) => {
              if (res)
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  text: "Invoice Created",
                });
            }
          );
          setInvoicePdfLink(upload?.data?.key);
          setLoading(false);
          setJobInfo(false);
        }
      }

    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable to Create Invoice",
      });
    }
  };
  const submitInvoice = async () => {
    setLoading(true);
    const data = {
      jobId: jobDetails.id,
      month,
      rate: hourlyRate,
      comments: comment,
      clientId: jobDetails.owner.id,
    };
    createInvoice(data).then((data) => {
      if (data?.exists) {
        setDisableTimesheet(true);
      } else if (data) {
        setInvoiceId(data.result.id);
        setInvoiceno(data.result.invoiceno);
      }
      setLoading(false);
    });
  };
  return (
    <div className="bg-white rounded-md mt-4 p-4">
      <SimpleBackdrop open={loading} />
      <div className="flex flex-row justify-between">
        <span>Preview</span>
        {invoicePdfLink && (
          <ShareLinkModal setLoading={setLoading} invoiceId={invoiceId} />
        )}
      </div>
      <div className="mt-5">
        <PDFViewer width={"100%"} height={700} showToolbar={false}>
          <Pdf />
        </PDFViewer>
      </div>
      {invoicePdfLink && (
        <div className="mt-5">
          <a
            href={invoicePdfLink}
            style={{
              border: "1px solid #2EBAA3",
              borderRadius: "4px",
              color: "#2EBAA3",
              padding: "0.6rem 2rem",
            }}
            download
            target="_blank"
            rel="noreferrer"
          >
            download invoice
          </a>
        </div>
      )}
      <div className="flex justify-end space-x-4 mt-4">
        <button
          onClick={() => {
            setPreview(false);
          }}
          style={{
            width: "144px",
            height: "34px",
            border: "1px solid #2EBAA3",
            borderRadius: "4px",
            color: "#2EBAA3",
          }}
        >
          Cancel
        </button>
        <button
          style={{
            width: "144px",
            height: "34px",
            background:
              disableTimesheet || hourlyRate === 0 ? "gray" : "#2EBAA3",
            borderRadius: "4px",
            color: "white",
          }}
          onClick={submitInvoice}
        >
          Submit
        </button>
      </div>
    </div>
  );
}
